import { render, staticRenderFns } from "./SupplierInbox.vue?vue&type=template&id=66fa3bf8&scoped=true&"
import script from "./SupplierInbox.vue?vue&type=script&lang=js&"
export * from "./SupplierInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa3bf8",
  null
  
)

export default component.exports